import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { IEvent } from '../models/event';
import { AuthService } from 'src/app/services/auth.service';
import { CompressImageService } from 'src/app/services/compress-image.service';
import { DataService } from 'src/app/services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { googleMapsLinkValidator } from '../utils/configuration';
import moment from 'moment';

@Component({
  selector: 'app-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss']
})
export class EventFormComponent implements OnInit, OnDestroy {
  @Input() state = 'create';
  @Input() imageUrl: any;
  @Input() selectedEvent: IEvent | null = null; 
  @Input() initialDate: Date | null = null; 
  @Output() saved = new EventEmitter();
  sendNotification = false;
  urlValid = false;
  createForm: FormGroup;
  private subs = new Subscription();
  private $imageCompressed = new EventEmitter();
  loading = false;
  isRecurringEvent = false;
  isEmojiPickerVisible = false;
  isEmojiPickerDescrVisible = false;
  public recurrentDays: any = [];
  days = [
    'lunes',
    'martes',
    'miércoles',
    'jueves',
    'viernes',
    'sabado',
    'domingo'
  ]

  constructor(
    private compressService: CompressImageService,
    public authService: AuthService,
    public dataService: DataService,
    private _snackBar: MatSnackBar,
    private changes: ChangeDetectorRef,
    private fb: FormBuilder
  ) { 

    this.createForm = this.fb.group({
      categories:  [[], Validators.required],
      startDateOfEvent: ['', Validators.required],
      dueDateOfEvent: ['', Validators.required],
      description: ['', Validators.required],
      fullName: ['', Validators.required],
      locationName:  ['', [googleMapsLinkValidator]], 
      availableReservation:  [false],
      image: ['', Validators.required],
      priceRange: ['', Validators.required],
      isOffer: [false],
    });

    this.subs = this.$imageCompressed.subscribe((compressedImage: any) => {
      let reader = new FileReader(); // HTML5 FileReader API
      // now you can do upload the compressed image 
      reader.readAsDataURL(compressedImage);
      // When file uploads set it to file formcontrol
      reader.onload = () => {
        this.imageUrl = reader.result
        this.createForm.patchValue({
          image: reader.result
        });
        this.changes.detectChanges();
      }
    });
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnChanges() {
    if (this.selectedEvent){
      const event = this.selectedEvent;
      this.createForm.setValue({
        categories:  event.categories,
        startDateOfEvent: new Date( event.startDateOfEvent.seconds * 1000),
        dueDateOfEvent: new Date(event.dueDateOfEvent.seconds * 1000),
        description: event.description,
        fullName: event.fullName,
        locationName: event.locationName,
        availableReservation: !!event?.availableReservation,
        image: this.imageUrl,
        priceRange: event.priceRange,
        isOffer: !!event?.isOffer,
      });
      this.createForm.updateValueAndValidity();

    } else {
      this.state = 'create';
    }

    if (this.initialDate) {
      this.createForm.patchValue({
        startDateOfEvent: this.initialDate,
      })
    }
  }

 async ngOnInit() {

  }


  public deleteImage(): void {
    this.imageUrl = null;
    this.createForm.patchValue({
      photoURL: null
    });
  }

  public uploadFile(event: any) {
    let file = event.target.files[0];

    if (event.target.files && event.target.files[0]) {
      this.compressImage(file)
    }
  }

 async loadFromURL(data: any){
   this.loading = true;
   try {
     const res: any = await this.dataService.getEventFromURL(data);
     this.createForm.patchValue({
      description: res.description,
      fullName: res.title,
      image: res.image
    });
    this.imageUrl = res.image;
    // this.$imageCompressed.next(res.image);
   } catch(e) {
      this._snackBar.open('Algo salio mal :(, intenta de nuevo', 'Ok', {
        duration: 3000
      });
   } finally{
     this.loading = false;
   }

  }

  addEmojiToTitle(event: any) {
    const res = this.createForm.controls.fullName.value + event.emoji.native;
    this.createForm.patchValue({
      fullName: res
    })
  }

  addEmojiToDescription(event: any) {
    const res = this.createForm.controls.description.value + event.emoji.native;
    this.createForm.patchValue({
      description: res
    });
  }

  saveEventChanges() {
    if (this.createForm.valid) {
      this.loading = true;

      if (this.state === 'create') {
        const event: IEvent = {
          ... this.createForm.value,
          dueDateOfEvent: new Date(this.createForm.get('dueDateOfEvent').value),
          startDateOfEvent: new Date(this.createForm.get('startDateOfEvent').value),
          createdAt: new Date(),
          brand: this.authService.userData.brandId,
          brandQuery: [this.authService.userData.brandId],
          likeCount: 0
        };
        if (this.recurrentDays.length > 0 && this.isRecurringEvent) {
          event['recurrentDays'] = this.recurrentDays;
        };
        
        this.dataService.createEvent(event, this.authService.userData, this.sendNotification).then(()=>{
          this._snackBar.open('Evento creado correctamente ;)', 'Ok', {
            duration: 3000
          });
          this.saved.emit(true);
          this.loading = false;
        })
      } else if (this.state === 'edit') {
        const event: IEvent = {
          ... this.createForm.value,
          id: this.selectedEvent.id,
          eventId: this.selectedEvent.id,
          dueDateOfEvent: new Date(this.createForm.get('dueDateOfEvent').value),
          startDateOfEvent: new Date(this.createForm.get('startDateOfEvent').value),
          createdAt: new Date(),
          brand: this.authService.userData.brandId,
          likeCount: 0
        };
        this.dataService.editEvent(event, this.authService.userData, this.sendNotification).then(()=>{
          this._snackBar.open('Evento creado correctamente ;)', 'Ok', {
            duration: 3000
          });
          this.saved.emit(this.createForm.value);
          this.loading = false;
        })
      }
    }
  }

  private compressImage(file: File): void {
    this.$imageCompressed.next(file);

    // this.compressService.compress(file)
    // .pipe(take(1))
    // .subscribe((compressedImage: any) => {
    //   return;
    // })
  }

  selectFile(fileInput: any) {
    fileInput.click(); 
    this.createForm.clearValidators();
    this.createForm.updateValueAndValidity();
  }

  checkToSendNotification(check: boolean) {
    this.sendNotification = check;
    console.log('');
    console.log('');
    console.log('this.sendNotification ', this.sendNotification);
    console.log('');
  }


  toggleCategory(category: any, event: any): void {
    const currentCategories: Array<string> = this.createForm.controls['categories'].value;
  
    if (event.checked) {
      const newCategories = [...currentCategories, category.categoryId];
      this.createForm.patchValue({
        categories: newCategories
      });
    } else {
      const index = currentCategories.indexOf(category.categoryId);
      if (index !== -1) {
        currentCategories.splice(index, 1); // Remove the item from the array
        this.createForm.patchValue({
          categories: currentCategories
        });
      }
    }
  }

  isCategorySelected(category: any): boolean {
    const categoriesArray = this.createForm.get('categories') as FormArray;
    return categoriesArray?.value?.indexOf(category.categoryId) !== -1;
  }

  markAsRecurrent(event: any) {
    console.log('');
    console.log('');
    console.log('event ', event);
    console.log('');
    console.log('');
    if (event.checked) {
      const ctrlValue = moment();
      ctrlValue.month('1');
      ctrlValue.day('1');
      ctrlValue.year(2050);
  
      this.createForm.patchValue({
        startDateOfEvent:ctrlValue
      });
      this.createForm.patchValue({
        dueDateOfEvent:ctrlValue
      });
      this.createForm.updateValueAndValidity();
    } else {
      this.createForm.patchValue({
        startDateOfEvent:null
      });
      this.createForm.patchValue({
        dueDateOfEvent:null
      });
      this.createForm.updateValueAndValidity();
    }
    this.isRecurringEvent = !this.isRecurringEvent;
  }


  checkDay(day: number, event: any) {
    if (event.checked) {
      this.recurrentDays.push(day)
    } else {
      this.recurrentDays.splice(this.recurrentDays.indexOf(day), 1)
    }
  }


}
